// import styles from './orders-page.module.scss'
import { IconActionHistory, PageHeader } from "@touche-lts/panel-ui/dist";
import cl from "classnames";
import { PageContainer } from "components";
import { observer } from "mobx-react-lite";
import { ActionHistoryTable } from "./action-history-table/action-history-table";
import styles from "./action-history.module.scss";

const ActionHistoryPageComponent = () => {
    return (
      <PageContainer className={cl("container", styles.scrollable)}>
        <div className="d-flex justify-content-around">
          <PageHeader
            navSegments={[
              {
                icon: IconActionHistory,
                label: "My action history",
              },
            ]}
            colorPreset="dark"
          />

          {/* <p>Period</p> // TODO-A This may be needed later
            <Select<OrdersPeriodFilter>
                colorPreset='dark'
                options={ordersPeriodFilterOptions}
                noNoneOption
                value={OrdersPeriodFilter.WEEK}
                placeholder='Past Week'
                className={styles.selectRootClassName}
                onChange={type =>
                    console.log(type)
                }
            />  */}
        </div>
        <ActionHistoryTable />
      </PageContainer>
    );
  },
  ActionHistory = observer(ActionHistoryPageComponent);
export { ActionHistory };
